import { render, staticRenderFns } from "./MessageRenderer.vue?vue&type=template&id=54898d66&scoped=true"
import script from "./MessageRenderer.vue?vue&type=script&lang=ts"
export * from "./MessageRenderer.vue?vue&type=script&lang=ts"
import style0 from "./MessageRenderer.vue?vue&type=style&index=0&id=54898d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54898d66",
  null
  
)

export default component.exports